import { createAsyncThunk } from '@reduxjs/toolkit';
import { getConnectwiseBoardTypes } from 'services/connectwise';

interface IProps {
  psaId: number;
  boardId: number;
}

export const ThunkGetConnectwiseBoardTypes = createAsyncThunk(
  'connectwise/getConnectwiseBoardTypes',
  ({ psaId, boardId }: IProps) => getConnectwiseBoardTypes(psaId, boardId).then(res => res.data),
);

export default {};
